export default {
  computed: {
    isRackingEnabledForInventoryProduct() {
      const { client : { inventory_settings : { enabled, enable_racking } } } = this.activeUser || {}
      return enabled && enable_racking;
    }
  }
};
